import * as React from 'react';

import { InvoiceRecord } from '@rematter/modules/finance/types';
import { Button, Menu } from '@rematter/ui-web';
import { BanknoteArrowUp, Eye, MoreHorizontal, Trash2 } from 'lucide-react';

import { useTranslations } from '@/finance/i18n/useTranslations';

type InvoiceActionMenuProps = {
  invoice: InvoiceRecord;
  onReceivePayment: (invoice: InvoiceRecord) => void;
  onVoid: (invoice: InvoiceRecord) => void;
  onViewDetails: (invoice: InvoiceRecord) => void;
};

export const InvoiceActionMenu = ({
  invoice,
  onReceivePayment,
  onVoid,
  onViewDetails,
}: InvoiceActionMenuProps) => {
  const t = useTranslations();

  const menuItems = React.useMemo(
    () => [
      {
        key: 'receive',
        label: t.invoices.list.buttons.receive,
        icon: <BanknoteArrowUp className="size-4" />,
        onAction: () => onReceivePayment(invoice),
        isDisabled: invoice.status !== 'Pending',
      },
      {
        key: 'void',
        label: t.invoices.list.buttons.void,
        icon: <Trash2 className="size-4" />,
        color: 'failure',
        onAction: () => onVoid(invoice),
        isDisabled: invoice.status === 'Voided' || invoice.status === 'Paid',
      },
      {
        key: 'viewDetails',
        label: t.invoices.list.buttons.viewDetails,
        icon: <Eye className="size-4" />,
        onAction: () => onViewDetails(invoice),
      },
    ],
    [invoice, onReceivePayment, onVoid, onViewDetails, t],
  );

  return (
    <div className="@InvoiceActionMenu flex justify-center">
      <Menu
        trigger={
          <Button size="icon" icon={<MoreHorizontal />} variant="outline" />
        }
        items={menuItems}
      />
    </div>
  );
};
